module.exports = __webpack_public_path__ + "img/Illustration-06.5ae5cccf.png";